/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Remind_Card_DetailInputs */

const en_portal_step_remind_card_detail = /** @type {(inputs: Portal_Step_Remind_Card_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming? Yes / Can't make it`)
};

const pl_portal_step_remind_card_detail = /** @type {(inputs: Portal_Step_Remind_Card_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Będziesz? Tak / Nie dam rady`)
};

/**
* | output |
* | --- |
* | "Coming? Yes / Can't make it" |
*
* @param {Portal_Step_Remind_Card_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_remind_card_detail = /** @type {((inputs?: Portal_Step_Remind_Card_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Remind_Card_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_remind_card_detail(inputs)
	return en_portal_step_remind_card_detail(inputs)
});